// extracted by mini-css-extract-plugin
export default {"selectable":"selectable_selectable__CmDne"};